import React from "react";
import {
    UiCol,
    UiRowContainer,
    UiSingleContainer,
    UiSingleRow,
} from "../../../components/grid-container/GridContainer";
import {
    UiTopBgSlider,
    UiTopBgSliderLeftContent,
    UiInnerTopBgSlider,
} from "../../../components/common/UiTopBgSliderElements";
import SliderHeart from "../../../../../styles/img/slider-heart-icon.png";
import UiInnerTopSliderCard from "../../../components/common/UiInnerTopSliderCard";
import { UiSliderImageCard } from "../../../components/common/UiSliderImageCard";
import { Button, Table } from "react-bootstrap";
import SpinWinImage from "../../../../../styles/img/spin-win-image.png";

export default function IncentiveBanner(props) {
    const learnMore = () => {};

    return (
        <>
            <UiInnerTopBgSlider>
                <UiTopBgSlider>
                    <UiCol lg="5">
                        <UiTopBgSliderLeftContent>
                        {props.topText && (
                            <p className="sb-top-bg-slider__slider-content__top-content">
                                {props.topText}{" "}
                            </p>
                            )}
                            {props.brandlogo ? (
                                <div className="d-flex align-items-center sb-top-left-logo-img">
                                    <img src={props.brandlogo} />{" "}
                                    <h2>{props.title}</h2>
                                </div>
                            ) : (
                                <h2>{props.title}</h2>
                            )}

                            <p className="sb-top-bg-slider__slider-content__description">
                                {props.description}
                            </p>
                            {props.secondDescription && (
                                <p className="sb-top-bg-slider__slider-content__description">
                                    {props.secondDescription}
                                </p>
                            )}

                            <div className="sb-top-bg-slider__slider-content__slider-bottom-info">
                                <div className="sb-incentive-status-col">
                                    {/* <span className="sb-incentive-status-col__green"></span>
                                    <span className="sb-incentive-status-col__status--active">{props.register ? 'You are registered' : 'Registration Open'}</span> */}
                                </div>
                            </div>
                            {props.join && (
                                <div className="sb-incentive-status-col-btm">
                                    <Button className="sb-primary-btn--38">
                                        Join Incentive
                                    </Button>
                                </div>
                            )}
                        </UiTopBgSliderLeftContent>
                    </UiCol>
                    <UiCol lg="7" className="mt-3 position-relative ">
                        {props.SpinWinImage ? (
                            <div className="sb-spin-win-right-img">
                                {" "}
                                <img src={SpinWinImage} />
                            </div>
                        ) : (
                            <UiSliderImageCard
                                image={props.sliderCardImage}
                                video={props.video}
                                content={props.content}
                                contentTitle={props.contentTitle}
                                contentDedsc={props.contentDedsc}
                                contentTopLeftAlign={props.contentTopLeftAlign}
                            />
                        )}
                    </UiCol>
                </UiTopBgSlider>
            </UiInnerTopBgSlider>
        </>
    );
}
